import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MatDialogModule,
} from '@angular/material/dialog';

/**
 * Confirmation dialog component
 *
 * A reusable dialog for confirming user actions with customizable text and buttons.
 *
 * @example
 * this.dialog.open(ConfirmationDialogComponent, {
 *   data: {
 *     title: 'Delete Item',
 *     message: 'Are you sure you want to delete this item?',
 *     confirmButtonText: 'Delete',
 *     cancelButtonText: 'Cancel',
 *   }
 * });
 */
@Component({
  selector: 'app-confirmation-dialog',
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title?: string;
      message: string;
      confirmButtonText: string;
      cancelButtonText: string;
    }
  ) {}

  /**
   * Closes the dialog with false result (cancel)
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Closes the dialog with true result (confirm)
   */
  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
